import React from 'react';

import BreakdownDetails from 'common/BreakdownDetails';

import { SUMMARY_SECTIONS } from '../summary/summarySectionsRegistry';

/**
 * Summary node — read-only review of everything the user just collected.
 *
 * Behaviour is fully driven by the flow config: `flowConfig.nodes[previousNodeId]
 * .summarySections` lists the section ids to render, in order. Each id is
 * resolved through `SUMMARY_SECTIONS` (registry) into `{ title, defaultOpen,
 * buildRows }`. `buildRows(data)` produces the rows; a common
 * `<BreakdownDetails>` view then renders every non-empty section as an
 * accordion. The presentation is shared with `BreakdownDetailsModal` (which
 * derives its own sections from the accepted `breakdown`).
 *
 * @param {import('common/activeElements/modals/FlowModal/flowTypes').FlowSummaryComponentProps} props
 */
const BreakdownSummaryStep = ({ data, flowConfig, previousNodeId }) => {
	const leafNode = previousNodeId ? flowConfig?.nodes?.[previousNodeId] : null;
	const sectionIds = leafNode?.summarySections ?? [];

	const sections = sectionIds
		.map((id) => {
			const section = SUMMARY_SECTIONS[id];
			if (!section) return null;
			return {
				id,
				title: section.title,
				defaultOpen: section.defaultOpen,
				rows: section.buildRows(data),
			};
		})
		.filter(Boolean);

	return <BreakdownDetails sections={sections} />;
};

export default BreakdownSummaryStep;
